import React from 'react';
import { useTranslation } from 'react-i18next';
//api
import {
  getLegalPrivacyNotice,
  createLegalPrivacyNotice,
  updateLegalPrivacyNotice
} from 'api/company';
//components
import LegalForm from './legalForm';

const PolicyForm = () => {
  const { t } = useTranslation(['footer']);

  return (
    <LegalForm
      fetchApi={getLegalPrivacyNotice}
      createApi={createLegalPrivacyNotice}
      updateApi={updateLegalPrivacyNotice}
      titleKey="title"
      textKey="text"
      title={t('legalprivacy')}
      dataTestId="legal-privacy"
    />
  );
};

export default PolicyForm;
